export default __webpack_public_path__ + "static/media/20-min.c2191663.png";